import { DeepReadonly } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const HIGHEST_QUALIFICATIONS: DeepReadonly<Array<{ value: string; label: string }>> = deepFreeze([
  { value: '99999', label: 'Not available' },
  { value: 'C0000', label: 'Certificate of Higher Education (CertHE)' },
  { value: 'C0001', label: 'Higher National Certificate (HNC)' },
  { value: 'C0004', label: 'National Vocational Qualification (NVQ) at level C' },
  { value: 'C0007', label: 'Other qualification at level C' },
  { value: 'C0008', label: 'Credits at level C' },
  { value: 'C0010', label: 'Higher Apprenticeship (level 4)' },
  { value: 'D0000', label: 'UK doctorate degree' },
  { value: 'D0001', label: 'Non-UK doctorate degree' },
  { value: 'D0002', label: 'Other qualification at level D' },
  { value: 'H0000', label: 'UK first degree with honours' },
  { value: 'H0001', label: 'Non-UK first degree' },
  {
    value: 'H0002',
    label:
      'First degree with honours leading to Qualified Teacher Status (QTS)/registration with a General Teaching Council (GTC)',
  },
  { value: 'H0013', label: 'Professional Graduate Certificate in Education' },
  { value: 'H0016', label: 'Other qualification at level H' },
  { value: 'I0000', label: 'UK ordinary (non-honours) first degree' },
  { value: 'J0000', label: 'Foundation degree' },
  { value: 'J0002', label: 'Diploma of Higher Education (DipHE)' },
  { value: 'J0003', label: 'Higher National Diploma (HND)' },
  { value: 'J0007', label: 'Scottish Vocational Qualification (SVQ) 4' },
  { value: 'J0008', label: 'Certificate in Education (CertEd) or Diploma in Education (DipEd)' },
  { value: 'J0009', label: 'Foundation course at level J' },
  { value: 'J0010', label: 'Other qualification at level J' },
  { value: 'M0000', label: 'UK masters degree' },
  { value: 'M0001', label: 'Non-UK masters degree' },
  {
    value: 'M0002',
    label: 'Integrated undergraduate/postgraduate taught masters degree on the enhanced/extended pattern',
  },
  { value: 'M0009', label: 'Diploma at level M' },
  { value: 'M0012', label: 'Certificate at level M' },
  {
    value: 'M0016',
    label: 'Postgraduate Certificate in Education or Professional Graduate Diploma in Education',
  },
  { value: 'M0021', label: 'Other taught qualification at level M' },
  { value: 'M0022', label: 'Credits at level M' },
  { value: 'P0000', label: 'Diploma at level 3' },
  { value: 'P0001', label: 'Certificate at level 3' },
  { value: 'P0002', label: 'Award at level 3' },
  { value: 'P0003', label: 'AQA Baccalaureate (Bacc)' },
  { value: 'P0004', label: 'A/AS level' },
  { value: 'P0005', label: '14-19 Advanced Diploma (level 3)' },
  { value: 'P0006', label: 'Scottish Baccalaureate' },
  { value: 'P0007', label: 'Scottish Highers/Advanced Highers' },
  { value: 'P0008', label: 'International Baccalaureate (IB) Diploma' },
  { value: 'P0009', label: 'International Baccalaureate (IB) Certificate' },
  { value: 'P0010', label: 'Cambridge Pre-U Diploma' },
  { value: 'P0011', label: 'Cambridge Pre-U Certificate' },
  { value: 'P0012', label: 'Welsh Baccalaureate Advanced Diploma (level 3)' },
  { value: 'P0013', label: 'Other qualification at level 3' },
  { value: 'P0014', label: 'UK Level 3 qualifications of which none are subject to UCAS Tariff' },
  { value: 'P0015', label: 'UK Level 3 qualifications of which all are subject to UCAS Tariff' },
  {
    value: 'P0016',
    label: 'Level 3 qualifications of which some are UK qualifications subject to UCAS Tariff',
  },
  { value: 'P0017', label: 'T levels' },
  { value: 'Q0000', label: '14-19 Higher Diploma (level 2)' },
  { value: 'Q0001', label: 'Welsh Baccalaureate Intermediate Diploma (level 2)' },
  { value: 'Q0002', label: 'Other qualification at level 2' },
  { value: 'R0000', label: '14-19 Foundation Diploma (level 1)' },
  { value: 'R0001', label: 'Welsh Baccalaureate Foundation Diploma (level 1)' },
  { value: 'R0002', label: 'Other qualification at level 1' },
  { value: 'X0000', label: 'Higher education (HE) access course, Quality Assurance Agency (QAA) recognised' },
  {
    value: 'X0001',
    label: 'Higher education (HE) access course, not Quality Assurance Agency (QAA) recognised',
  },
  { value: 'X0002', label: 'Mature student admitted on basis of previous experience and/or admissions test' },
  { value: 'X0003', label: 'Other qualification level not known' },
  { value: 'X0004', label: 'Student has no formal qualification' },
]);

export const HIGHEST_QUALIFICATIONS_LIST = deepFreeze(
  HIGHEST_QUALIFICATIONS.map((qualification: { value: string; label: string }) => ({
    label: `${qualification.value} - ${qualification.label}`,
    value: qualification.value,
  })),
);

export const HIGHEST_QUALIFICATIONS_MAP = deepFreeze(
  HIGHEST_QUALIFICATIONS.reduce(
    (map, qualification) => {
      map[qualification.value] = qualification.label;
      return map;
    },
    {} as Record<string, string>,
  ),
);
